import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { HelperModule } from '../../modules/helper.module';
import { MatDialog } from '@angular/material/dialog';
import { ApiServiceModule } from '../../modules/api-service.module';
import { SharedService } from '../../modules/shared-service.service';
import { DomSanitizer } from '@angular/platform-browser';
import config from 'config/default.json';
@Component({
  selector: 'app-vcl-student-dashboard',
  templateUrl: './vcl-student-dashboard.component.html',
  styleUrls: ['./vcl-student-dashboard.component.scss']
})
export class VcStudentDashboardComponent {
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer) {}
  @Input() userInfos: { [x:string]: any } = new Map();
  @Output() inProgress = new EventEmitter<any>();
  pageId = 'vcl-dashboard'
  modes:{ [x:string]: string|number }[] = [];

  data:{[x: string]: any} = {};
  platformInfos:{[x: string]: any} = {origin: 'virtualclass', key: 'vcl', root: 'VIRTUALCLASS'}
  ngOnInit(): void {

  }
  loadDashboardData(data:any){
    this.inProgress.emit(true);
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/dashboard/load', {form_data: data, platform_infos: this.platformInfos}, this.userInfos['access_token']).subscribe((response)=>{
     
      this.data = response;
    }) 
  }
}
